import { Flex } from "@chakra-ui/react";
import { EventType } from "@models/event";
import { DEFAULT_LANGUAGE, Language } from "@models/language";
import { AiFillLinkedin } from "react-icons/ai";
import { BsTwitter } from "react-icons/bs";
import { HiOutlineUpload, HiShare } from "react-icons/hi";
import { MdEmail } from "react-icons/md";
import {
  EmailShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
import { CardCover, ShowChildrenOnHoverCard } from "../CheckoutSuccessCTA";

const _t = (key?: string, language = DEFAULT_LANGUAGE) => key || "";

const ShareEventCard = ({
  language = DEFAULT_LANGUAGE,
  eventType,
  url,
}: {
  language?: Language;
  eventType?: EventType;
  url: string;
}) => {
  const returnTitle = (eventType: EventType | undefined) => {
    switch (eventType) {
      case EventType.BENEFIT:
        return _t("Share Redeemable", language);

      case EventType.TICKET:
        return _t("Share Ticket", language);

      case EventType.MEMBERSHIP:
      default:
        return _t("Share", language);
    }
  };

  return (
    <ShowChildrenOnHoverCard
      cover=<CardCover
        icon={
          eventType === EventType.MEMBERSHIP ? <HiOutlineUpload /> : <HiShare />
        }
        alt="ticket icon"
        title={returnTitle(eventType)}
      />
    >
      <Flex
        direction="row"
        gap={6}
        justifyContent="center"
        width="100%"
        alignItems="center"
        fontSize="1.2em"
        className="text-primary"
      >
        <TwitterShareButton url={url}>
          <BsTwitter />
        </TwitterShareButton>
        <EmailShareButton url={url}>
          <MdEmail />
        </EmailShareButton>
        <LinkedinShareButton url={url}>
          <AiFillLinkedin />
        </LinkedinShareButton>
      </Flex>
    </ShowChildrenOnHoverCard>
  );
};

export default ShareEventCard;
